import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from '../Tooltip';
import {TooltipWrap} from '../TooltipWrap';
import {highlighterReducer, INITIAL_STATE, EVENTS} from './Highlighter.reducer';
import style from './style.module.scss';

export function Highlighter(props) {
  const [state, dispatch] = React.useReducer(highlighterReducer, INITIAL_STATE);

  const fetchDetails = async () => {
    try {
      dispatch({type: EVENTS.FETCH_DETAILS_STARTED});
      let response = await props.getContentData(props.contentID);
      dispatch({type: EVENTS.FETCH_DETAILS_SUCCESS, payload: response});
    } catch (error) {
      dispatch({type: EVENTS.FETCH_DETAILS_FAILED});
    }
  };

  React.useEffect(() => {
    if (state.tooltipOpen) {
      fetchDetails();
    }
  }, [state.tooltipOpen]);

  const closeTooltip = () => {
    dispatch({type: EVENTS.CLOSE_TOOLTIP});
  };

  const openTooltip = () => {
    dispatch({type: EVENTS.OPEN_TOOLTIP});
  };

  const onHighlightClik = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // If no content ID is defined, open the full glossary list and skip the tool-tip
    if(props.contentID === ''){
      props.openGlossary('')
    } else {
      openTooltip();
    }
  };

  const renderTooltip = () => (
    <TooltipWrap tooltipOpen={state.tooltipOpen}>
      <Tooltip
        close={closeTooltip}
        onRetry={fetchDetails}
        {...state.tooltipDetails}
        tooltipApi={state.tooltipApi}
        openGlossary={props.openGlossary}
        contentID={props.contentID}
      />
    </TooltipWrap>
  );

  return (
    <em
      className={`${style.highlight} ${style[props.color]}`}
      onClick={onHighlightClik}>
      {renderTooltip()}
      {props.children}
    </em>
  );
}

Highlighter.propTypes = {
  /**
   * String value for highlight color
   */
  color: PropTypes.oneOf(['yellow', 'red', 'blue', 'green']),
  /**
   * UniqueID of the content being highlighted
   */
  contentID: PropTypes.string.isRequired,
  /**
   * Async function to call when you need to fetch data for the Tooltip
   */
  getContentData: PropTypes.func.isRequired,
  /**
   * Function invoked when you wanna open the glossary
   */
  openGlossary: PropTypes.func.isRequired,
};

Highlighter.defaultProps = {
  color: 'blue',
};
